<template>
  <div class="flex" style="height: 100%">
    <div ref="kfbview" class="flex-1 full-height flex justify-content-center"></div>
    <hzzt-toolbox :current-angle="angle" :label-list="labelRegionList" @tool="toolMethod"
                  @change-setting="changeSetting" 
                  @force-redraw="forceRedraw"
                  @set-deg="setDeg"
                  @focus-view="changeFocusView" @change-show-label="changeShowLabel"></hzzt-toolbox>
    <hzzt-control ref="hzztControl" :scale="zoom" @zoom-to="zoomTo" />
    <el-dialog
      :visible.sync="imageInfoView"
      :append-to-body="true"
      class="image-info"
      title="Image information"
      width="700px"
      top="5vh"
    >
      <el-form label-position="left" label-width="100px">
        <el-form-item label="fileName">
          <span class="flex-1">{{ imageInfo.fileName }}</span>
        </el-form-item>
        <el-form-item label="size">
          <span class="flex-1">{{ imageInfo.width }} Pixel - {{ imageInfo.height }} Pixel</span>
        </el-form-item>
        <el-form-item label="scanScale">
          <span class="flex-1">{{ imageInfo.scanScale + 'x' || null }}</span>
        </el-form-item>
        <el-form-item label="scanTime">
          <span class="flex-1">{{ formatDate(imageInfo.scanTime) }}</span>
        </el-form-item>
        <el-form-item label="scanDuration">
          <span class="flex-1">{{ imageInfo.scanDuration || 0 }}s</span>
        </el-form-item>
        <el-form-item label="previewImage" label-position="top"/>
        <el-form-item class="flex" label-width="0px">
          <img :src="imageInfo.labelImg" alt="labelImg" class="preview-img">
          <img :src="imageInfo.previewImg" alt="previewImg" class="preview-img flex-1">
        </el-form-item>
      </el-form>
    </el-dialog>
    <span v-if="category" @click="go" class="viewMore">view more</span>
  </div>
</template>

<script>
import { cacheGammaTable, hslToRgb, KfbView, rgbToHsl } from 'kfb-view'
import axios from 'axios'
import HzztControl from './HzztControl'
import HzztToolbox from './HzztToolbox'
export default {
  components: { HzztControl, HzztToolbox },
  props: ['data', 'fileName', 'category'],
  data() {
    return {
      info: {},
      list: [],
      detection: [],
      zoom: 1,
      type: 'tct',
      kv: null,
      count: 8000,
      imgUrl: null,
      showImg: false,
      angle: 0,
      boardOptions: {
        ROI: false,
        disabled: false,
      },
      areaOptions: {
        disabled: false,
        drag: true,
        thumb: true,
        thumbRadius: 5,
        thumbColor: '#01d0b0',
      },
      graduationOptions: {
        disabled: false,
        left: 0,
        right: 30,
        top: 0,
        bottom: 0,
      },
      tailoringOptions: {
        now: false,
        width: 200,
        height: 200,
        left: 0,
        top: 0,
        color: '#FF0000',
      },
      navigatorOptions: {
        disabled: false,
        width: 200,
        height: 200,
        vestige: true,
        vestigeDelay: 1000,
        vestigeColor: 'rgba(255, 0, 255, .5)',
        vestigeZoom: 10,
      },
      pxConversion: {
        unit: 'um',
      },
      imageProcess: {
        r: 0,
        g: 0,
        b: 0,
        s: 0,
        l: 0,
        a: 1
      },
      drawOptions: {
        lineWidth: 2,
        strokeStyle: '#027AFF',
        fillStyle: '',
        text: '编辑文字',
        measure: true,
        move: true,
        resize: true,
        isROI: false,
        isClose: true,
        once: false,
        clear: true,
        fontSize: 14,
      },
      cacheImage: {},
      showSlideInfo: true,
      showDiagnosisInfo: true,
      showLabelStatus:true,
      imageInfoView: false,
      labelRegionList: [],
      imageInfo: {
        ...this.data,
        scanScale: 20,
        labelImg: `https://www.kfbiopathology.com/kfb/image?file=${this.fileName}&type=label`,
        previewImg: `https://www.kfbiopathology.com/kfb/image?file=${this.fileName}&type=preview`,
        fileName: this.fileName
      },
    }
  },
  methods: {
    go() {
      window.open('http://kcloud.kfbio.cn/Slide?path=aHR0cDovL2tjbG91ZGJ1Y2tldC5vc3MtY24taGFuZ3pob3UtaW50ZXJuYWwuYWxpeXVuY3MuY29tLzIwMjItNC0xMi9jM2E0LThlNzEtMGQxZS1lNjA1LTUxY2MtZGJhYy0yY2EyLWRmOGEua2ZiZg%3D%3D')
    },
    initKfbView(data) {
      if (!data?.width) {
        return;
      }
      const params = {}
      params.file = this.fileName
      const that = this
      this.kv = new KfbView({
        el: that.$refs.kfbview,
        fileName: that.fileName,
        scale: data.scanScale,
        area: that.areaOptions,
        board: that.boardOptions,
        graduation: that.graduationOptions,
        navigator: {
          style: 'left: 0;bottom: 0',
          thumbnail: `/kfb/image?file=${that.fileName}&type=thumbnail`,
          ...that.navigatorOptions,
          vestigeZoom: that.navigatorOptions.vestigeZoom / data.scanScale,
        },
        openSeadragonOptions: {
          maxZoomLevel: data.scanScale * 10,
          imageLoaderLimit: 1,
          animationTime: 0,
          pixelsPerArrowPress: 120,
          tileSources: {
            height: data.height,
            width: data.width,
            // tileSize: 256,
            tileSize: data.imageBlockLen,
            minLevel: 10,
            encodeQueryData(data) {
              const ret = [];
              for (const d in data) {
                if (Object.prototype.hasOwnProperty.call(data, d)) {
                  ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
                }
              }
              return ret.join('&');
            },
            getTileUrl(level, x, y) {
              params.x = x
              params.y = y
              // temp workaround, need to fix hzztImageOperation library for return fileNum @gikidy
              const maxLen = Math.max(data.width, data.height)
              if (Math.pow(2, data.fileNum - 1) === maxLen) {
                data.fileNum--
              }
              if (data.fileNum === level) {
                level = data.scanScale
                params.scale = level.toFixed(6)
              } else {
                level = data.scanScale / Math.pow(2, data.fileNum - level)
                params.scale = level.toFixed(6)
                level = data.ratiomap[level.toFixed(6)]
                if (level === undefined) {
                  level = 0
                }
              }
              params.level = level
              return `https://www.kfbiopathology.com/kfb/image?${this.encodeQueryData(params)}`
            },
          },
        },
        pxConversion: {
          imageCapRes: data.imageCapRes,
          unit: that.pxConversion.unit,
        },
        labelList: that.list,
        tileDrawing(e) {
          const {
            context,
            rendered,
            sourceWidth,
            sourceHeight,
            position,
            size,
            initRendered,
            tile,
          } = e
          const rangeA = that.imageProcess.a
          const rangeS = that.imageProcess.s
          const rangeL = that.imageProcess.l
          const rangeR = that.imageProcess.r
          const rangeG = that.imageProcess.g
          const rangeB = that.imageProcess.b
          if (
            rangeB === 0 &&
            rangeA === 1 &&
            rangeS === 0 &&
            rangeL === 0 &&
            rangeR === 0 &&
            rangeG === 0
          ) {
            context.drawImage(
              rendered.canvas,
              0,
              0,
              sourceWidth,
              sourceHeight,
              position.x,
              position.y,
              size.x,
              size.y
            )
            return
          }
          if (!that.cacheImage[tile.url]) {
            const sourceLength = sourceWidth * sourceHeight
            const canvas = rendered.canvas
            let imageData = initRendered.getImageData(
              0,
              0,
              canvas.width,
              canvas.height
            )
            for (let i = 0; i < sourceLength; i++) {
              let r = imageData.data[i * 4 + 0]
              let g = imageData.data[i * 4 + 1]
              let b = imageData.data[i * 4 + 2]
              if (rangeR !== 0) {
                r = r * (1 + rangeR)
                r = r > 255 ? 255 : r
              }
              if (rangeG !== 0) {
                g = g * (1 + rangeG)
                g = g > 255 ? 255 : g
              }
              if (rangeB !== 0) {
                b = b * (1 + rangeB)
                g = g > 255 ? 255 : g
              }
              if (rangeS !== 0) {
                const { h, s, l } = rgbToHsl(r, g, b)
                const rgb = hslToRgb(h, s * (1 + rangeS), l)
                r = rgb.r
                g = rgb.g
                b = rgb.b
              }
              if (rangeL !== 0) {
                const { h, s, l } = rgbToHsl(r, g, b)
                const rgb = hslToRgb(h, s, l * (1 + rangeL))
                r = rgb.r
                g = rgb.g
                b = rgb.b
              }
              if (rangeA !== 1) {
                r = cacheGammaTable[rangeA][r >> 0]
                g = cacheGammaTable[rangeA][g >> 0]
                b = cacheGammaTable[rangeA][b >> 0]
              }
              if (r > 255 || g > 255 || b > 255) {
                console.log(r, g, b)
              }
              imageData.data[i * 4 + 0] = r
              imageData.data[i * 4 + 1] = g
              imageData.data[i * 4 + 2] = b
            }
            rendered.putImageData(imageData, 0, 0)
            that.cacheImage[tile.url] = canvas
          }
          context.drawImage(
            that.cacheImage[tile.url],
            0,
            0,
            sourceWidth,
            sourceHeight,
            position.x,
            position.y,
            size.x,
            size.y
          )
        },
      })
      this.kv.viewer.addHandler('zoom', (res) => {
        const _zoom =
          this.kv.viewer.viewport.viewportToImageZoom(res.zoom) *
          this.kv.$options.scale
        this.zoom = _zoom.toFixed(2) / 1
      })
      this.kv.$on(KfbView.events.EVENT_END_PAINTING, (e) => {
        this.list.push(e.detail)
        this.kv.initLabelList(this.list)
      })
      this.kv.$on(KfbView.events.EVENT_TAILORING_SCREENSHOT, (e) => {
        this.imgUrl = e.detail
        this.showImg = true
      })
      this.tailoringOptions.left = this.kv.$options.width / 2 - 100
      this.tailoringOptions.top = this.kv.$options.height / 2 - 100
    },
    zoomTo(zoom) {
      if (zoom === 1) {
        this.kv.viewer.viewport.goHome()
      } else {
        const _zoom = this.kv.viewer.viewport.imageToViewportZoom(zoom / 1)
        this.kv.viewer.viewport.zoomTo(_zoom / this.kv.$options.scale)
      }
    },
    forceRedraw(process) {
      this.cacheImage = {}
      this.imageProcess = process
      this.kv.viewer.forceRedraw()
    },
    reloadKfb() {
      this.kv?.destroy?.()
      setTimeout(() => {
        this.initKfbView(this.info)
      })
    },
    initLabels() {
      for (let i = 0; i < this.detection.length; i++) {
        const point = {
          x: this.detection[i].region.x,
          y: this.detection[i].region.y,
        }
        const colors = ['#027AFF', '#f56c6c']
        const label = {
          // fillStyle: 'rgba(2, 122, 255, 1)',
          lineWidth: this.detection[i].width,
          points: [point, point],
          scale: this.detection[i].scale,
          strokeStyle: '#00ff00',
          tool: this.detection[i].type,
          move: false,
        }
        this.list.push(label)
      }
      this.kv.initLabelList(this.list)
    },
    customScreenshot() {
      this.kv.tailoring.init(this.tailoringOptions)
    },
    rotation() {
      this.kv.viewer.viewport.setRotation(this.angle)
      this.kv.change()
    },
    stopDraw() {
      this.kv.board.endDraw()
    },
    changeSetting(type, flag) {
      if (type === 'grid') {
        this.kv.grid.updated({
          show: flag,
        });
      } else if (type === 'ruler') {
        this.kv.grid.updated({
          ruler: flag,
        });
        this.kv.navigator.element.style.left = flag ? '22px' : 0;
      } else if (type === 'navigator') {
        this.kv.navigator.element.style.display = flag ? 'flex' : 'none';
      } else if (type === 'graduation') {
        this.kv.graduation.updated({
          show: flag,
        });
      } else {
        this.handlerChangeSetting(type, flag);
      }
    },
    handlerChangeSetting(type, flag) {
      if (type === 'zoom') {
        this.$refs.hzztControl.$el.style.display = flag ? 'flex' : 'none';
      } else if (type === 'slide') {
        this.showSlideInfo = flag;
      } else if (type === 'diagnosis') {
        this.showDiagnosisInfo = flag;
      }
    },
    setDeg(deg) {
      this.angle = deg.toFixed(2) / 1;
      this.kv.viewer.viewport.setRotation(this.angle);
    },
    changeFocusView(type) {
      this.kv.navigator.element.style.left = type ? '22px' : 0;
      this.kv.navigator.element.style.display = type ? 'flex' : 'none';
      this.kv.graduation.updated({
        show: type,
      });
      this.$refs.hzztControl.$el.style.display = type ? 'flex' : 'none';
      this.showSlideInfo = type;
      this.showDiagnosisInfo = type;
    },
    changeShowLabel(status){
      this.showLabelStatus = status
      this.getLabelList()
    },
    getLabelList() {
      axios.get(`/api/kfb/ai_json/${this.type}`).then(({data}) => {
        this.detection = data.label.detection
      })
    },
    toolMethod(name, tool) {
      if (name === 'tailor') {
        const {width, height} = this.kv.$options;
        this.kv.tailoring.init(
          {
            left: width / 2 - 100,
            top: height / 2 - 100,
            height: 200,
            width: 200,
            color: '#ff0000',
          });
      } else if (name === 'image-info') {
        this.imageInfoView = true;
      }
    },
    formatDate(time) {
      const da = new Date(time * 1000)
      const year = da.getFullYear()
      const month = da.getMonth() + 1
      const date = da.getDate()
      return [year,month,date].join('-')
    }
  },
  watch: {
    fileName() {
      this.reloadKfb()
    },
    data() {
      this.info = this.data
      this.reloadKfb()
    }
  },
  created() {
    this.getLabelList()
    this.info = this.data
    if(!this.info?.width) {
      return;
    }
    console.log(this.info);
    this.initKfbView(this.info)
    this.initLabels();
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/responsive';
.full-height {
  //width: px(1120);
  //height: px(600);
  //width: 100%;
  height: 100%;
}
.image-info {
  .preview-img {
    height: 180px;

    img {
      height: 100%;
    }
  }

  .el-form-item {
    word-break: break-all;

    &.el-form-item {
      margin-bottom: 0;
    }
  }
}
.viewMore {
  position: absolute;
  bottom: 60px;
  right: 50px;
  color: #fff;
  font-weight: 500;
  font-size: 22px;
  cursor: pointer;
  &:hover {
    color: #289aff;
    text-decoration: underline;
  }
}
</style>